import react, { useEffect, useState } from "react";
const markerComponentIsPropsEqual = (prev, next)=>{
    const messageKeysList = Object.keys(prev?.message || {});
    const sameMessage = messageKeysList.every((key)=>prev?.message[key] === next?.message[key]);
    const markerComponentPropsKeysList = Object.keys(prev?.message?.markerComponentProps || {});
    const sameMarkerComponentProps = markerComponentPropsKeysList.every((key)=>prev?.message?.markerComponentProps[key] === next?.message?.markerComponentProps[key]);
    return sameMessage && sameMarkerComponentProps;
};
const useMarkerComponentMemo = (markerComponents)=>{
    const [memoMarkerComponents, setMemoMarkerComponents] = useState({});
    const componentCount = Object.keys(markerComponents || {}).length;
    useEffect(()=>{
        if (!markerComponents || 'object' != typeof markerComponents) return;
        const memoList = {};
        Object.keys(markerComponents).forEach((key)=>{
            const component = markerComponents[key];
            if ('function' == typeof component) memoList[key] = /*#__PURE__*/ react.memo(component, markerComponentIsPropsEqual);
        });
        setMemoMarkerComponents(memoList);
    }, [
        componentCount
    ]);
    return memoMarkerComponents;
};
export { markerComponentIsPropsEqual, useMarkerComponentMemo };
